import { useEffect, useState } from 'react'

export function useAnimationDelay(delay: number = 0) {
  const [shouldAnimate, setShouldAnimate] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldAnimate(true)
    }, delay)

    return () => clearTimeout(timer)
  }, [delay])

  return shouldAnimate
}

export function useStaggeredAnimation(itemCount: number, baseDelay: number = 0, staggerDelay: number = 100) {
  const [animatedItems, setAnimatedItems] = useState<boolean[]>(new Array(itemCount).fill(false))

  useEffect(() => {
    const timers: NodeJS.Timeout[] = []

    for (let i = 0; i < itemCount; i++) {
      const timer = setTimeout(() => {
        setAnimatedItems(prev => {
          const newState = [...prev]
          newState[i] = true
          return newState
        })
      }, baseDelay + i * staggerDelay)
      
      timers.push(timer)
    }

    return () => {
      timers.forEach(timer => clearTimeout(timer))
    }
  }, [itemCount, baseDelay, staggerDelay])

  return animatedItems
}